import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { RequestListService } from '../../services/request-list.service';
import { GetRequestListPayload } from '../../types/request-params';

@Component({
   selector: 'app-request-list-toolbar',
   templateUrl: './request-list-toolbar.component.html',
   styleUrls: ['./request-list-toolbar.component.scss']
})
export class RequestListToolbarComponent implements OnInit {
   private _activeOnly: boolean;
   @Input() payload: GetRequestListPayload;
   @Input()
   get activeOnly(): boolean {
      return this._activeOnly;
   }
   set activeOnly(value: boolean) {
      this._activeOnly = value;
      this.setActiveOnlyText()
   }

   @Output() addRequest = new EventEmitter();
   @Output() searchChange = new EventEmitter<string>();
   @Output() activeOnlyChange = new EventEmitter<boolean>();
   @Output() toggleChange = new EventEmitter<boolean>();

   toggle: boolean = false;
   activeOnlyText: string;

   constructor(
      private service: RequestListService
   ) { }

   ngOnInit(): void {
      this.searchChange.emit(null)
   }

   export = () => {
      this.service.getRequestExport(this.payload).subscribe();
   }

   activeOnlyToggle() {
      this.activeOnly = !this.activeOnly;
      this.activeOnlyChange.emit(this.activeOnly);
   }

   setActiveOnlyText() {
      this.activeOnlyText = this.activeOnly ? 'Click to include Inactive Requests' : 'Click to exclude Inactive Requests'
   }

   onToggle() {
      this.toggle = !this.toggle;
      this.toggleChange.emit(this.toggle);
   }
}